import { ReactElement, useMemo } from 'react'
import {
    StyledPartnerCard,
    StyledNextTime,
    CloseIcon,
    PartnerImage,
    PartnerInfo,
} from './styles'
import { Image, SVG, Text } from '../../Atoms'
import { PriceWithVAT, StarsWithTotal } from '../../Molecules'
import { PartnerCardProps } from './props'
import { SVGs } from '../..'

const PartnerCard = ({
    alias,
    backgroundWhite,
    image,
    isSelected,
    noReviewsText = 'New at RaskRask',
    numberOfReviews,
    price,
    rating,
    text,
    vatText,
    ...props
}: PartnerCardProps): ReactElement => {
    const partnerImage = useMemo(
        () => (
            <PartnerImage>
                <Image
                    src={
                        image ??
                        'https://www.raskrask.dk/wp-content/themes/rask/images/massoer_no_pic.png.webp'
                    }
                    alt={`${alias ?? 'No'} profile`}
                />
            </PartnerImage>
        ),
        [alias, image]
    )

    const partnerInfo = useMemo(
        () => (
            <PartnerInfo>
                <Text size={{ '@initial': 'm', '@desktop': 'l' }} primary bold>
                    {alias}
                </Text>
                {numberOfReviews && rating ? (
                    <StarsWithTotal
                        rating={rating}
                        numberOfReviews={numberOfReviews}
                        size={{ '@mobile': 's', '@desktop': 'm' }}
                    />
                ) : (
                    <Text>{noReviewsText}</Text>
                )}
                {price && (
                    <PriceWithVAT
                        css={{
                            '@desktop': { flexDirection: 'column', gap: 0 },
                        }}
                        price={price}
                        priceSize={{ '@mobile': 'l', '@desktop': 'xl' }}
                        vatText={vatText}
                        vatTextSize={{
                            '@mobile': 'xs',
                            '@desktop': 's',
                        }}
                    />
                )}
            </PartnerInfo>
        ),
        [alias, noReviewsText, numberOfReviews, price, rating, vatText]
    )

    return (
        <StyledPartnerCard {...props} isSelected={isSelected}>
            {isSelected && (
                <CloseIcon>
                    <SVG src={SVGs.CloseCircleFilled} />
                </CloseIcon>
            )}
            {partnerImage}
            {partnerInfo}
            {text && (
                <StyledNextTime backgroundWhite={backgroundWhite}>
                    {text}
                </StyledNextTime>
            )}
        </StyledPartnerCard>
    )
}

export default PartnerCard

export { StyledPartnerCard }
